module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_2-28ebc0579212c8e3c621da24c8e780e2.png";